import { Deserializable } from '../protocols/deserializable';
import { AnnuitySetupSubmissionData } from './annuity-setup-submission-data';

export class AnnuitySetupSubmission implements Deserializable {
  public new!: AnnuitySetupSubmissionData;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    if (this.new) {
      this.new = Deserialize.instanceOf(AnnuitySetupSubmissionData, this.new);
    }
  }
}
